<div class="app-content dialog-password">
  <div class="app-title">
    <h1 class="title">ផ្លាស់ប្តូរពាក្យសម្ងាត់</h1>
  </div>

  <div mat-dialog-content>
    <form id="form" [formGroup]="form" class="creation-form" autocomplete="off">
      <div class="grid gap-x-16 col-sm-2">
        <div class="grid gap-x-16 col-sm-2 col-span-sm-2">
          <div>
            <label class="required">លេខសំងាត់​បច្ចុប្បន្ន</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                [type]="hideOldPassword ? 'password' : 'text'"
                formControlName="old_password"
                autocomplete="off"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="hideOldPassword = !hideOldPassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideOldPassword"
              >
                <mat-icon class="text-primary">{{hideOldPassword ? 'visibility_off' : 'visibility'}} </mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div></div>
        </div>
        <div>
          <label class="required">ពាក្យសម្ងាត់​ថ្មី</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [type]="hideNewPassword ? 'password' : 'text'"
              formControlName="new_password"
              autocomplete="new-password"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hideNewPassword = !hideNewPassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideNewPassword"
            >
              <mat-icon class="text-primary">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('new_password').errors?.minlength">
              យ៉ាងហោចណាស់ 8 ខ្ទង់
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <label>បញ្ជាក់ពាក្យសម្ងាត់</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirm_password"
              autocomplete="off"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hideConfirmPassword = !hideConfirmPassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideConfirmPassword"
            >
              <mat-icon class="text-primary">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}} </mat-icon>
            </button>
            <mat-error *ngIf="form.get('confirm_password').errors?.nomatch">
              ពាក្យសម្ងាត់ត្រូវតែផ្គូផ្គង
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" form="form" (click)="onSubmit()">រួចរាល់</button>
  </div>
</div>
